import React from 'react';
import { buildBreadcrumbTrail } from '../config/routeConfig';

interface BreadcrumbsProps {
  currentPath: string;
  onNavigate: (routeId: string, params?: Record<string, string>, data?: Record<string, any>) => void;
  contextData?: Record<string, any>;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ currentPath, onNavigate, contextData = {} }) => {
  // Build breadcrumb trail dynamically from route config
  const breadcrumbs = buildBreadcrumbTrail(currentPath, contextData);

  const handleBreadcrumbClick = (routeId: string) => {
    // Clear context data when navigating back
    onNavigate(routeId, {}, {});
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 0',
      fontSize: '0.9rem',
      color: '#666',
    }}>
      <i className="pi pi-home" style={{ fontSize: '1rem', color: '#0f3d3e' }}></i>
      
      {breadcrumbs.map((item, index) => (
        <React.Fragment key={`${item.id}-${index}`}>
          {index > 0 && (
            <i className="pi pi-chevron-right" style={{ 
              fontSize: '0.7rem', 
              color: '#ccc',
              margin: '0 4px'
            }}></i>
          )}
          
          {index === breadcrumbs.length - 1 ? (
            // Current page - not clickable
            <span style={{
              color: '#0f3d3e',
              fontWeight: '600',
            }}>
              {item.label}
            </span>
          ) : (
            // Previous pages - clickable
            <button
              onClick={() => handleBreadcrumbClick(item.id)}
              style={{
                background: 'none',
                border: 'none',
                color: '#666',
                cursor: 'pointer',
                padding: '4px 8px',
                borderRadius: '6px',
                transition: 'all 0.2s ease',
                fontSize: '0.9rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#f0f0f0';
                e.currentTarget.style.color = '#0f3d3e';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'none';
                e.currentTarget.style.color = '#666';
              }}
            >
              {item.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;